<template>
    <b-container>
        <b-card>
    <b-breadcrumb>
        <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
        <b-breadcrumb-item active>Ward Inbound Messages</b-breadcrumb-item>
    </b-breadcrumb>   
    <b-alert variant="warning" :show="ward.twilio_test">
        Ward({{ward.ward_type}}) is currently in test mode, no messages will go out.
    </b-alert>                  
            <b-row>
                <b-col>
                <h4 class="ml-3 mb-3">Ward({{ward.ward_type}}) Inbound Messages:</h4>
                <p>Any messages sent to the twilio number will be shown in the below list.</p>
                </b-col>
                <b-col>
    <b-card v-if="accountBalance !== null && accountBalance !== undefined">
        <h4>Twilio Balance: ${{accountBalance.balance.toFixed(2)}} {{accountBalance.currency}}</h4>
    </b-card>                     
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button
                    @click="refresInboundMessageList()"
                    class="float-right"
                    variant="secondary">
                    <font-awesome-icon icon="redo" />
                </b-button> 
                </b-col>
            </b-row>            
            <b-row>
                <b-col>                    
                    <b-table
                        :fields="table.fields"
                        :items="table.items"
                        :busy="table.isBusy"
                        class="mb-3 mt-3"
                        show-empty
                        responsive
                        empty-text="No Inbound Messages to show"
                        outlined>
                        <template v-slot:cell(Action)="row">
                            <b-button :key="row.item.uid" :to="{name: 'ward-message', params: { 'wardId': wardId, 'messageId': row.item.message_id, 'stakeId': stakeId}}" variant="outline-secondary"> 
                            <font-awesome-icon icon="eye" />
                            </b-button>
                        </template>                        
                        <template #table-busy>
                          <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                        </template>
                        <template #cell(show_details)="row">
                          <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                            {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                          </b-button>
                        </template>
                        <template #cell(from_info)="row">                             
                            {{(row.item.contact_info!==null)?row.item.contact_info.first_name:'Unknown'}} 
                            {{(row.item.contact_info!==null)?row.item.contact_info.last_name:''}}
                            &lt; {{row.item.from_number}} &gt;
                        </template>                          
                        <template #cell(created_on)="row">
                            <span :id="'tooltip-created-inbound' + row.index">{{$moment.utc(row.item.created_on).local().fromNow()}}</span>
                            <b-tooltip :target="'tooltip-created-inbound' + row.index" triggers="hover">
                                {{$moment.utc(row.item.created_on).local().format('llll')}}
                            </b-tooltip>                             
                        </template>                    
                        <template #row-details="row">
                          <b-card>   
                            <b-row class="mb-2">
                              <b-col sm="3" class="text-sm-right"><b>Message Action:</b></b-col>
                              <b-col class="text-sm-left"><b-button
                               variant="outline-secondary"
                               size="sm"
                               :href="generateReplyText(row.item)">
                               <font-awesome-icon icon="reply" /> Reply To Contact</b-button>
                              </b-col>
                            </b-row>                                                                                      
                            <b-row class="mb-2">
                              <b-col sm="3" class="text-sm-right"><b>Inbound Message:</b></b-col>
                              <b-col><pre>{{ row.item.from_message }}</pre></b-col>
                            </b-row>
                            <b-row class="mb-2" v-if="row.item.originals !== null">
                                <b-col sm="3" class="text-sm-right"><b>Potential Original Message Sent:</b></b-col>
                                <b-col>
                                    <ul>
                                    <li v-for="(original) in row.item.originals">
                                        <b-button
                                        v-if="original.msg_id !== undefined && original.msg_id !== null && original.msg_id !== ''"
                                        variant="outline-secondary"
                                        size="sm"
                                        :to="{name: 'ward-message', params: {wardId: wardId, messageId: original.msg_id}}">
                                        <font-awesome-icon icon="sms" /> Outbound Message</b-button><br/>
                                        <b>Sent On:</b> {{ $moment.utc(original.sent_on).local().format('llll')}}<br/>
                                        <b>Sent By:</b> {{ original.sent_by }}<br/>
                                        <b>Target Group:</b> {{ original.group_name }}<br/>
                                        <pre>{{ original.message }}</pre><br/>                                        
                                    </li>                                    
                                    </ul>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                              <b-col sm="3" class="text-sm-right"><b>Auto Reply Message:</b></b-col>
                              <b-col><pre>{{ row.item.reply_message }}</pre></b-col>
                            </b-row>
                            <b-row class="mb-2" v-if="row.item.contact_info!==null">
                              <b-col sm="3" class="text-sm-right"><b>Primary Organization:</b></b-col>
                              <b-col><pre>{{ getOrganizationInfo(row.item.contact_info.primary_organization).text }} </pre></b-col>
                            </b-row>
                            <b-row class="mb-2" v-if="row.item.contact_info!==null">
                              <b-col sm="3" class="text-sm-right"><b>Auxilary Organization:</b></b-col>
                              <b-col><pre>{{ flattenAuxOrganizations(row.item.contact_info.aux_organization).text }}</pre></b-col>
                            </b-row>                                                                               
                          </b-card>
                        </template>                                                            
                    </b-table>                     
                </b-col>
            </b-row>
        <b-row>
            <b-col align="center">
                <b-button-group v-if="pages.length>1">
                    <b-button @click="searchInboundMessages(currentPage-1)">Prev</b-button>
                    <b-button @click="searchInboundMessages(currentPage+1)">Next</b-button>
                </b-button-group>                
            </b-col>
        </b-row>            
        </b-card>        
    </b-container>
</template>
<script>
import { MessageApi } from "@/app/messages/messageApi";
import { WardApi } from "@/app/wards/wardApi";
import handleError from "@/errorHandler";

export default {
    name: "WardInboundMessageList",
    props: {
        wardId: {
            type: String,
            required: false,
            default: null
        },
        stakeId: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            ward: {
                ward_name: null
            },
            organizations: [],
            messageStates: [],
            searchTerm : 'ALL',
            messageState: 'PENDING',
            nextPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },
            prevPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },
            pages: [],
            currentPage: 0,
            lastPage: 0,
            table: {
                id: "inbound-message-list",
                fields: [     
                    {
                        key: "from_info",
                        label: "From"

                    },           
                    {
                        key: "created_on",
                        label: "Received"
                    },

                    {
                        key: "show_details",
                        label: "Details"

                    }
                ],
                items: [],
                isBusy: false,
                totalRows: 0,
                page: {
                    index: 1,
                    size: 5
                }

            },
            accountBalance: {
                balance: 0.00
            }         

        }

    },
    async mounted() {
        this.messageStates = this.$store.state.frontEndSettings.message_states;
        if(this.wardId !== null){
            await this.getOrganizations();
            await this.getAccountBalance();
        }
        this.pages.push(this.nextPage);
        await this.searchInboundMessages(0);
    },
    methods: {
        async getAccountBalance(){
            try{
                const { data } = await WardApi.getWardAccountBalance(this.wardId);
                this.accountBalance = data;
            }catch (e) {
                handleError(e, "Failed to get accouunt balance")
            }


        },
        async getOrganizations() {
            try{
                const { data } = await WardApi.getWardOrganizations(this.wardId);
                // load everything
                this.organizations.push({
                    value: 'ALL',
                    text: 'All Organizations'
                })
                data.org_list.forEach(x=>{
                    this.organizations.push({
                        value: x.org_code,
                        text: x.org_name
                    })
                })
                this.ward = data.ward;
            }catch (e) {
                handleError(e, "Failed to get organization info");
            }            
        },
        async searchInboundMessages(page) {
            if(page < 0) {
                return;
            }
            if(page > this.pages.length -1) {
                return;
            }

            const payload = this.pages[page];
            payload.search_term = this.searchTerm;
            payload.message_state = this.messageState;
            this.table.isBusy = true;
            try{
                const { data } = await MessageApi.getMessageInboundList(this.wardId, payload);

                if(data.last_evaluated_key !== null) {
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key);
                }
                this.table.items = data.message_list;
                this.table.isBusy = false;
                this.currentPage = page;
            } catch (e) {
                handleError(e, "Failed to fetch messages");
                console.error(e);
            }

        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if(list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;
        },
        async refresInboundMessageList() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchInboundMessages(0);
        },
        getOrganizationInfo(value) {
            var i;
            for (i=0; i < this.organizations.length; i++) {
                if(this.organizations[i].value==value)
                    return this.organizations[i];
            }
        }, 
        
        flattenAuxOrganizations(list_of_orgs) {
            if(list_of_orgs === undefined) return 'None';
            if(list_of_orgs.length==0) return 'None';
            return list_of_orgs.map(x=>
            {
                return this.getOrganizationInfo(x).text;
            }).join(', ');

        },
        getMessageStateInfo(value) {
            var i;
            for (i=0; i < this.messageStates.length; i++) {
                if(this.messageStates[i].value==value)
                    return this.messageStates[i];
            }            
        },
        generateReplyText(item) {
            const fromMessage = encodeURI(item.from_message);
            const fromNumber = item.from_number
            const body = `sms:${fromNumber}&body=RE:${fromMessage}`;
            return body;
        }
    }
    
    
}
</script>
<style lang="scss">
pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}
</style>